var map = {
	"./BOT.jpg": 8386,
	"./TOP.jpg": 9354,
	"./image1.jpg": 2390,
	"./image10.png": 73,
	"./image2.jpg": 1374,
	"./image3.jpg": 5680,
	"./image4.jpg": 6692,
	"./image5.jpg": 5904,
	"./image6.jpg": 3262,
	"./image7.jpg": 7421,
	"./image8.png": 2089,
	"./image9.png": 9800,
	"./logo.png": 6949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2206;